export default __webpack_public_path__ + "files/webinar5.pdf";